
export function isErrorResponse(obj: any): obj is { error: any } {
    return !!(obj.error)
  }
  